
import React from 'react';
import PropTypes from 'prop-types';
import 'components/styles/layout.css';
import Footer from 'components/footer';
import Header from 'components/header';
import MainForm from 'components/main-form';
import LanguageToggle from 'components/language-toggle';

const Layout = ({ partner }) => {
  const { allowedLangCodes, defaultLangCode} = partner || {};
  const showLanguageToggle = allowedLangCodes?.length > 1 ;
  return (
    <div className="main">
      <Header partner={partner} />
      <div className="content-area">
        <div className="language-toggle-wrapper">
          <LanguageToggle showLanguageToggle={showLanguageToggle} preselectLang={defaultLangCode} />
        </div>
        <MainForm partner={partner} />
      </div>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  partner: PropTypes.object,
};

export default Layout;
